var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategory7 = function SvgCategory7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "category7_svg__w-full category7_svg__h-full",
    viewBox: "0 0 68 62"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#727277",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    clipPath: "url(#category7_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.074h8.283l8.442 35.914h39.54l10.104-23.015H11.513M60.024 49.457H11.28V36.988h5.445M29.223 55.192c0-3.167-2.532-5.735-5.656-5.735s-5.656 2.568-5.656 5.735 2.532 5.735 5.656 5.735 5.656-2.568 5.656-5.735ZM54.315 55.192c0-3.167-2.532-5.735-5.656-5.735s-5.656 2.568-5.656 5.735 2.532 5.735 5.656 5.735 5.656-2.568 5.656-5.735Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "category7_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h68v62H0z"
  })))));
};
export default SvgCategory7;